import { useContext, useEffect, useState } from 'react'

import { SL_Modal } from '../../components/modal/Modal'
import { ModalTitle } from './components/ModalTitle'
import { ChoseCentral } from './components/ChoseCentral'
import { ReportTable } from './components/ReportTable'
import { ShowSVG } from '../../components/showSVG/ShowSVG'

import { GeneralContext } from '../../context/GeneralContext/GeneralContext'
import { displayMessage } from '../../helpers/messages'
import { EAlertTypes } from '../../enums/EAlertTypes'
import api from '../../services/api'

export const AlertLogsModal = ({ onClose }) => {
    const { windowHeight, windowWidth, showAlert } = useContext(GeneralContext)
    const [actions, setActions] = useState(null)
    const [central, setCentral] = useState(null)

    const [appliedFilters, setAppliedFilters] = useState({})

    const [showMore, setShowMore] = useState(true)
    const [showLoading, setShowLoading] = useState(false)
    const filters = ['deviceName', 'deviceType','sector', 'alertType', 'datetime']

    const modalHeigth = windowHeight * 0.7
    const limit = 10

    const columns = [
        {
            dataIndex: 'icon',
            title: '',
            width: 60,
            ellipsis: true,
            noExport: true,
        }, {
            dataIndex: 'description',
            title: displayMessage('ALERT_NAME'),
            width: 300,
            ellipsis: true,
        },
        {
            dataIndex: 'device_name',
            title: displayMessage('DEVICE_NAME'),
            width: 300,
            ellipsis: true,
        },
        {
            dataIndex: 'sector',
            title: displayMessage('ZONE_NAME'),
            width: 200,
            ellipsis: true,
        },
        {
            dataIndex: 'location',
            title: displayMessage('LOCATION_DESCRIPTION'),
            width: 240,
            ellipsis: true,
        },
        {
            dataIndex: 'painel_date',
            title: displayMessage('ALERT_DATE'),
            width: 200,
            ellipsis: true,
        },
        {
            dataIndex: 'status_name',
            title: displayMessage('STATUS'),
            width: 200,
            ellipsis: true,
        },
    ]

    const getReportData = async (params, id = central, resetTable) => {
        setShowLoading(true)
        try {
            params = {
                ...params,
                ...resetTable ? {} : appliedFilters,
                limit,
                offset: params?.offset || 0,
                painel: true,
            }
            const { data } = await api.alertLogReports.reportsByCentral(id, params)

            const newActions = data.map((action) => ({ ...action, icon: <ShowSVG icon={action.icon} className="report-table-icon" /> }))
            setActions((current) => ((!current || resetTable) ? newActions : current.concat(newActions)))
            if (limit > data.length) {
                setShowMore(false)
            }
        } catch (error) {
            console.log(error)
        } finally {
            setShowLoading(false)
        }
    }

    const onFilter = (filters, central, cleaning) => {
        if(cleaning) {
            setAppliedFilters({})
            if(central) {
                getReportData({}, central, true)
            } else {
                showAlert(displayMessage("CLEANED_FILTERS_INFO"), EAlertTypes.SUCCESS)
             }
            return 
        }
        setCentral(central)
        setAppliedFilters({})
        setAppliedFilters(filters)
        
        getReportData(filters, central, true)
    }

    useEffect(() => {
        if (central) {
            setActions(null)
            setShowMore(true)
            getReportData(null, central)
        }
    }, [central]) 

    return (
        <SL_Modal
            open={true}
            title={<ModalTitle onCloseButtonClick={onClose} title={displayMessage('ALERT_LOGS_TITLE')} data={actions} columns={columns} filters={filters}  onFilter={onFilter} central_id={central}/>}
            closable={false}
            closeIcon={null}
            footer={null}
            width={windowWidth * 0.9}
            bodyStyle={{
                height: modalHeigth,
                padding: '2.22vh',
            }}
        >
            <ChoseCentral onChangeCentral={setCentral} central_id={central}/>
            <ReportTable columns={columns} data={actions} height={modalHeigth - 200} onShowMore={getReportData} showMoreOptions={showMore} loading={showLoading} limit={limit} filters={appliedFilters} central={central}/>
        </SL_Modal>
    )
}
